import Commons from '../../../Services/Common/Common';

export const WOS_BASIC_Schema = {
  mapper: {
    /** 작업중지 목록 조회 GetWosBasicR1 (SP_WOS_BASIC_R1 변경분 반영) */
    search1: {
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
      SearchText: (context) =>
        Commons.EncryptAES(context.searchText ?? '') || '',
    },
  },
};
